import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Shipments from "@/pages/Shipments";
import ShipmentDetail from "@/pages/ShipmentDetail";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Finance from "@/pages/Finance";
import TrackShipment from "@/pages/TrackShipment";
import Layout from "@/components/Layout";
import { FIN_ROLES } from "@/lib/stages";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#0B0F19] text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function FinanceOnly({ children }) {
  const { user } = useAuth();
  if (!FIN_ROLES.includes(user?.role)) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/shipments" element={<Protected><Shipments /></Protected>} />
          <Route path="/shipments/:id" element={<Protected><ShipmentDetail /></Protected>} />
          <Route path="/users" element={<Protected><AdminOnly><Users /></AdminOnly></Protected>} />
          <Route path="/finance" element={<Protected><FinanceOnly><Finance /></FinanceOnly></Protected>} />
          <Route path="/settings" element={<Protected><AdminOnly><Settings /></AdminOnly></Protected>} />
          <Route path="/track/:token" element={<TrackShipment />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </AuthProvider>
  );
}

export default App;
